/**
Project: Voice Panel (c)
Title: Summary 
Description: Component to show the summary of the DNS setup
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import { Text, Button, LikeIcon, } from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import { VoiceAdminURLProps } from "../../common/settings/voice-admin-urls";
import IntlUtil from "../../../../core/helpers/intl-util";

class Summary extends Component {
    _intl_ns_vpa_domainsetup = "vpa_domainsetup";
    loadNextPage = async () => {
        this.props.history.push(VoiceAdminURLProps.home);
    };

    render() {
        return (
            <Grid fluid className="page-grid m-t-15">
                <Row>
                    <Col xs={12} className="m-b-20">
                        <Text className="page-heading4">
                            {IntlUtil.getText(
                                this._intl_ns_vpa_domainsetup,
                                "content.summary.activationComplete"
                            )}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <Row>
                            <Col xs={12} className="m-b-10">
                                <Text className="page-text">
                                    {IntlUtil.getText(
                                        this._intl_ns_vpa_domainsetup,
                                        "content.summary.callUsingSippio"
                                    )}
                                </Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="m-b-10 ">
                                <Text className="page-text">
                                    {IntlUtil.getText(
                                        this._intl_ns_vpa_domainsetup,
                                        "content.summary.AppStore"
                                    )}
                                </Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="m-b-10 m-t-10">
                                <a className="page-text text-fc-primary text-semibold"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href="https://appsource.microsoft.com/en-us/?search=sippio">
                                    <LikeIcon className="m-r-5 p-b-5 p-t-5" />
                                    <Text content={IntlUtil.getText(
                                        this._intl_ns_vpa_domainsetup,
                                        "content.summary.appStoreButton"
                                    )} />
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="m-b-20 m-t-10">
                        <Button
                            primary
                            content={IntlUtil.getText(
                                this._intl_ns_vpa_domainsetup,
                                "content.done"
                            )}
                            // disabled={!this.state.isFormDataFilled}
                            onClick={this.loadNextPage}
                            className="vpa-voice-setup-button"
                        />
                    </Col>
                </Row>
            </Grid>
        )
    }
}


const mapStateToProps = (state) => ({
    domainSetupProgressPage: state.domainSetupStore.domainSetupProgressPage,
    domainSetupProgressAccountNumber: state.domainSetupStore.domainSetupProgressAccountNumber,
});

const mapActionToProps = {
};

export default connect(mapStateToProps, mapActionToProps)(Summary);